import * as React from 'react'
import styled, { AnyStyledComponent } from 'styled-components'
import injectGoogleMaps from 'utils/injectGoogleMaps'

interface IProps {
  setMap?: any
  setMarker?: any
  latitude: number | null
  longitude: number | null
  google: any
}

export const InlineGoogleMap: React.FC<IProps> = ({
  setMap,
  setMarker,
  latitude,
  longitude,
  google,
}) => {
  const [initialized, setInitialized] = React.useState(false)
  const initializeMap = () => {
    const LatLng = new google.maps.LatLng(latitude, longitude)
    const Options = {
      zoom: 15,
      center: LatLng,
      mapTypeId: 'roadmap',
      scrollwheel: false,
      draggable: false,
    }
    const initializedMap = new google.maps.Map(document.getElementById('map'), Options)
    const initializedMarker = new google.maps.Marker({
      position: LatLng,
      map: initializedMap,
    })

    if (setMap) {
      setMap(initializedMap)
    }
    if (setMarker) {
      setMarker(initializedMarker)
    }
    setInitialized(true)
  }

  React.useEffect(() => {
    if (!initialized && google && latitude && longitude) {
      initializeMap()
    }
  }, [google, latitude, longitude])

  return (
    <S.Map id="map" className={`Map${latitude !== null && longitude !== null ? '' : ' hide'}`} />
  )
}
const S: { [key: string]: AnyStyledComponent } = {}

S.Map = styled.div`
  margin-top: 16px;
  height: 320px;
  &.hide {
    display: none;
  }
`
export default injectGoogleMaps(InlineGoogleMap)
